import {Box} from '@mui/material';
import {AppConfirmationDialog, AppConfirmationDialogRefType} from 'components/dialogs';
import {AppItemDataSelect} from 'components/form';
import {SelectOptionsType} from 'global';
import {useCreateTimeTrackerEntity, useStopTimeTrackerEntity, useTimeTrackerinRedux} from 'hooks';
import {TimeTrackerModel, TimeTrackerStatus} from 'models';
import {BoardDefaultStatusType} from 'models/board';
import React, {useEffect, useRef} from 'react';
import {useForm} from 'react-hook-form';
import {useSelector} from 'react-redux';
import {timeTrackerSelector} from 'store/timeTracker';
export interface TimeTrackerItemSelectProps {
    afterCreateUpdateHandler: (item: TimeTrackerModel) => void;
}
interface SelectedItemOptions {
    selectedOption: SelectOptionsType | null;
}
export const TimeTrackerItemSelect: React.FC<TimeTrackerItemSelectProps> = ({afterCreateUpdateHandler}) => {
    // const {getAllItemDataOfTenant, getAllItemDataOfTenantLoading, getAllItemDataOfTenantResponse} =
    //     useGetAllItemDataOfTenat();
    const {watch, control} = useForm<SelectedItemOptions>();
    const {isConuterStarted, selectedTimeTrackInRedux} = useSelector(timeTrackerSelector);
    const {startConterInRedux, stopCounterInRedux, setTimeTrackerEntityInRedux} = useTimeTrackerinRedux();
    const {stopTimeTrackerEntity, stopTimeTrackerEntityLoading, stopTimeTrackerEntityResponse} =
        useStopTimeTrackerEntity();
    const confirmationDialiogRef = useRef<AppConfirmationDialogRefType>(null);
    const {createTimeTrackerEntity, createTimeTrackerEntityLoading, createTimeTrackerEntityResponse} =
        useCreateTimeTrackerEntity();
    const selectedOptionWatch = watch('selectedOption');

    useEffect(() => {
        if (selectedOptionWatch?.value) {
            if (!isConuterStarted) {
                createTimeTrackerEntity({
                    variables: {
                        input: {
                            itemDataId: selectedOptionWatch.value,
                            startTime: new Date().toISOString(),
                            title: selectedOptionWatch.label,
                            description: selectedOptionWatch.label,
                            status: TimeTrackerStatus.Running.toString(),
                        },
                    },
                });
            } else {
                if (confirmationDialiogRef.current) {
                    confirmationDialiogRef.current.handleOpen();
                }
            }
        }
    }, [selectedOptionWatch]);

    useEffect(() => {
        if (!createTimeTrackerEntityLoading && createTimeTrackerEntityResponse) {
            if (createTimeTrackerEntityResponse.status !== TimeTrackerStatus.Running) {
                afterCreateUpdateHandler(createTimeTrackerEntityResponse);
            }
            setTimeTrackerEntityInRedux(createTimeTrackerEntityResponse);
            startConterInRedux();
        }
    }, [createTimeTrackerEntityLoading, createTimeTrackerEntityResponse]);

    const onConfimationHandler = () => {
        if (selectedTimeTrackInRedux) {
            stopCounterInRedux();
            stopTimeTrackerEntity({
                variables: {
                    id: selectedTimeTrackInRedux.id,
                },
            });
        }
    };
    useEffect(() => {
        if (stopTimeTrackerEntityResponse && !stopTimeTrackerEntityLoading) {
            afterCreateUpdateHandler(stopTimeTrackerEntityResponse);
            if (selectedOptionWatch?.value) {
                createTimeTrackerEntity({
                    variables: {
                        input: {
                            itemDataId: selectedOptionWatch.value.toString(),
                            startTime: new Date().toISOString(),
                            title: selectedOptionWatch.label,
                            description: selectedOptionWatch.label,
                            status: TimeTrackerStatus.Running.toString(),
                        },
                    },
                });
            }
        }
    }, [stopTimeTrackerEntityResponse, stopTimeTrackerEntityLoading]);

    return (
        <>
            <Box>
                <AppItemDataSelect
                    filters={{
                        itemStatusTypes: [BoardDefaultStatusType.Open],
                    }}
                    label={'Select another item to track'}
                    control={control}
                    name="selectedOption"
                />
            </Box>
            <AppConfirmationDialog
                renderElement={() => <></>}
                ref={confirmationDialiogRef}
                onConfirmClick={(_open, _handleOpen, handleClose) => {
                    onConfimationHandler();
                    handleClose();
                }}
                title={'Are you sure you wan to stop the timer?'}
                description={'This will stop the timer and save the time entry and start a new one.'}
            />
        </>
    );
};

export default TimeTrackerItemSelect;
